export default __webpack_public_path__ + "static/media/precios_LEED_feb_eng_B.71d5e060.png";